// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `svg .info-icon {
  fill: #5E5D5C;
}

svg .cross-icon{
  fill: #0479CD;
}`, "",{"version":3,"sources":["webpack://./node_modules/@alinta-digital/asg/icons/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf","sourcesContent":["svg .info-icon {\r\n  fill: #5E5D5C;\r\n}\r\n\r\nsvg .cross-icon{\r\n  fill: #0479CD;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
